<template>
  <div class="area">
    <div class="title">片区信息</div>
    <el-row class="el-line">
      <el-form label-width="100px" class="line" :inline="true">
        <el-form-item label="片区编号:" class="elForm">
          <el-input v-model="spaceData.space.spaceNo" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="片区名称:" style="margin-left: 40px" class="elForm">
          <el-input v-model="spaceData.space.name" readonly disabled></el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="el-line">
      <el-form label-width="100px" class="line" :inline="true">
        <el-form-item label="创建人:" class="elForm">
          <el-input v-model="spaceData.space.createPersonName" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="创建时间:" style="margin-left: 40px" class="elForm">
          <el-input v-model="spaceData.space.gmtCreate" readonly disabled></el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-divider></el-divider>

    <div class="title" style="margin-bottom: 15px">租赁信息</div>
    <vxe-table
      border
      ref="xTable"
      :data="spaceData.spaceLease.childLeaseDTOs"
      show-summary
      :summary-method="getSummaries"
      @cell-dblclick="cellDBLClickEvent"
    >
      <vxe-table-column title="资产编号" field="spaceNo"> </vxe-table-column>
      <vxe-table-column title="资产名称" field="name"> </vxe-table-column>
      <template>
        <vxe-table-column :key="index" v-for="(i, index) in tableColumn" :title="i.title">
          <vxe-table-column
            :key="index"
            v-for="(item, index) in i.children"
            :title="item.title"
            :field="item.field"
          >
            <template v-slot="{ row }">
              <span v-if="item.field == 'leasedNum'">
                <a
                  @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                  href="#"
                  style="color: blue; cursor: pointer"
                  >{{ row[item.field] }}</a
                >
              </span>
              <span v-else-if="item.field == 'beLeasedNum'">
                <a
                  @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                  href="#"
                  style="color: blue; cursor: pointer"
                  >{{ row[item.field] }}</a
                >
              </span>
              <span v-else-if="item.field == 'beEffectiveNum'">
                <a
                  @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                  href="#"
                  style="color: blue; cursor: pointer"
                  >{{ row[item.field] }}</a
                >
              </span>
              <span v-else-if="item.field == 'expiredNum'">
                <a
                  @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                  href="#"
                  style="color: blue; cursor: pointer"
                  >{{ row[item.field] }}</a
                >
              </span>
              <span v-else>{{ row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </vxe-table-column>
      </template>
    </vxe-table>
    <el-row class="enable-button" type="flex" justify="center">
      <el-button
        v-for="item in areaButtonList"
        :type="item.label == '禁用' ? 'danger' : 'primary'"
        :key="item.id"
        :disabled="
          item.label == '禁用' ? spaceData.space.isEnabled == 0 : spaceData.space.isEnabled == 1
        "
        @click="click(item.attributes.buttonUrl)"
        class="fixed-bottom-btn"
        >{{ item.label }}</el-button
      >
      <!-- <el-button type="primary"  :disabled="spaceData.space.isEnabled == 1" @click="enable(true)"
        >启用</el-button
      >
      <el-button type="danger" :disabled="spaceData.space.isEnabled == 0" @click="enable(false)"
        >禁用</el-button
      > -->
    </el-row>
    <SpaceInfoDialog
      :showDialog.sync="showSpaceInfoDialog"
      :title="spaceInfoDialogTitle"
      :tableData="spaceInfoDialogData"
      v-if="showSpaceInfoDialog"
      @closeDialog="showSpaceInfoDialog = false"
    />
  </div>
</template>
<script>
  import API from '@/api/property/spaceAssets';
  import mixin from '../mixins/mixin';
  import { generalFormItem } from '@/api/property/model';
  import SpaceInfoDialog from './spaceInfoDialog.vue';
  export default {
    name: 'AreaInformation',
    mixins: [mixin],
    props: {
      form: {
        type: Object,
        default: () => {},
      },
      showAreaData: {
        type: Object,
        default: () => {},
      },
      areaButtonList: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      SpaceInfoDialog,
    },
    computed: {
      tableColumn() {
        return [
          // {
          //   field: 'spaceNo',
          //   title: '资产编号',
          //   visible: true,
          // },
          // {
          //   field: 'name',
          //   title: '资产名称',
          //   visible: true,
          // },
          {
            title: '空间',
            children: [
              {
                field: 'spacesNum',
                title: '空间数',
                visible: true,
              },
              {
                field: 'totalSpaceArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '已出租',
            children: [
              {
                field: 'leasedNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalLeasedArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '待出租',
            children: [
              {
                field: 'beLeasedNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalBeLeasedArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '待生效',
            children: [
              {
                field: 'beEffectiveNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalBeEffectiveArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '已失效',
            children: [
              {
                field: 'expiredNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalExpiredArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
        ];
      },
    },
    watch: {
      showAreaData: {
        handler: function (newVal) {
          console.log('areaInformationCard_showAreaData', newVal);
          if (newVal.id != null) {
            this.getSpaceDetail();
          }
        },
        deep: true,
      },
    },
    data() {
      return {
        spaceData: { space: {}, spaceLease: {} },
        spaceInfoDialogTitle: '',
        spaceInfoDialogData: [],
        showSpaceInfoDialog: false,
      };
    },
    mounted() {
      this.getSpaceDetail();
    },
    methods: {
      openSpaceInfoDialog(field, spaceNo) {
        let spaceInfo = this.spaceData.spaceLease.childLeaseDTOs.filter(
          (item) => item.spaceNo == spaceNo
        );
        if (field == 'leasedNum') {
          console.log('11111111');
          this.spaceInfoDialogTitle = '已出租';
          this.spaceInfoDialogData =
            spaceInfo[0].leasedSpaces != null ? spaceInfo[0].leasedSpaces : [];
        } else if (field == 'beLeasedNum') {
          this.spaceInfoDialogTitle = '待出租';
          this.spaceInfoDialogData =
            spaceInfo[0].beLeasedSpaces != null ? spaceInfo[0].beLeasedSpaces : [];
        } else if (field == 'beEffectiveNum') {
          this.spaceInfoDialogTitle = '待生效';
          this.spaceInfoDialogData =
            spaceInfo[0].beEffectiveSpaces != null ? spaceInfo[0].beEffectiveSpaces : [];
        } else if (field == 'expiredNum') {
          this.spaceInfoDialogTitle = '已失效';
          this.spaceInfoDialogData =
            spaceInfo[0].expiredSpaces != null ? spaceInfo[0].expiredSpaces : [];
        }
        this.showSpaceInfoDialog = true;
      },
      // 菜单按钮点击处理
      click(type) {
        if (type == 'enable') {
          this.enable(true);
        } else if (type == 'disable') {
          this.enable(false);
        }
      },
      enable(status) {
        var message = '确认启用该片区吗？';
        if (!status) {
          message = '确认禁用该片区吗？';
        }
        this.$confirmAction('', message).then(async () => {
          const { data } = await this.$axios.post(API.SPACE_ENABLE, {
            isEnabled: status ? 1 : 0,
            id: this.showAreaData.id,
          });
          if (data.code == 0) {
            this.$message.success('操作成功');
            this.$emit('refreshTree', true);
            this.getSpaceDetail();
          } else {
            if (data.msg != '') {
              return this.$message.error(data.msg);
            }
            this.$message.error('操作失败');
          }
        });
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '';
            return;
          }
          if (index === 1) {
            sums[index] = '合计：';
            return;
          }
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = 'N/A';
          }
        });

        return sums;
      },
      cellDBLClickEvent() {},
      //获取公司信息
      getSpaceDetail() {
        if (this.showAreaData.type != '01') {
          return;
        }
        this.$axios.get(API.SPACE + '/' + this.showAreaData.id).then((res) => {
          console.log('getSpaceDetail', res);

          if (res.data.code == '0') {
            this.spaceData = res.data.data;
            console.log('getSpaceDetail', this.spaceData);

            if (this.spaceData.space == null) {
              this.spaceData.space = {};
            }
            if (this.spaceData.spaceLease == null) {
              this.spaceData.spaceLease = {};
            }
          }
        });
      },
      update(data) {
        let params = JSON.parse(JSON.stringify(generalFormItem));
        params.energyDTOList = null;
        params.spaceDTO = this.spaceData.space;
        params.spaceDTO.name = data;
        params.spaceLeaseDTO = this.spaceData.spaceLease;
        this.$axios.post(API.SPACE_UPDATE, params).then((res) => {
          if (res.data.code == '0') {
            this.spaceData.space.name = data;
            this.$emit('updateSucess', { type: '0', data: data });
            this.$message.success('更新成功');
          } else {
            this.$message.error(res.data.msg);
            this.$emit('updateSucess', { type: '1', data: data });
          }
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .area {
    margin-left: 20px;
    margin-top: 15px;
    background-color: white;
    // width: 100%;
    .title {
      font-size: 14px;
      color: black;
      margin-left: 10px;
    }
    .elForm ::v-deep .el-form-item__label {
      font-size: 13px;
      width: 50%;
      color: black;
    }
    ::v-deep .el-input {
      width: 250px;
    }
    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin-bottom: 20px;
    }
    .line {
      width: 100%;
      display: flex;
    }
    .el-line {
      margin-left: 10px;
    }
    ::v-deep .el-table th.el-table__cell {
      background-color: #f6f7f9;
    }
    ::v-deep .el-table__footer-wrapper tbody td.el-table__cell,
    .el-table__header-wrapper tbody td.el-table__cell {
      background-color: white;
    }
    ::v-deep .vxe-table .vxe-table--empty-placeholder {
      display: none;
    }
    ::v-deep .vxe-table .vxe-table--empty-block {
      visibility: unset !important;
    }
    .el-table::before {
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0px;
    }
    ::v-deep .el-table .el-table__cell {
      text-align: center;
    }
    .enable-button {
      margin-top: 30px;
    }
  }
</style>
